import React from 'react';
import './ConferenceCountdown.css';

function ConferenceCountdown({ language }) {
  const title = language === 'zh' ? '会议已结束' : 'CONFERENCE ENDED';
  const description = language === 'zh' ? '2026年4月11—12日' : 'April 11–12, 2026';

  return (
    <div className="conference-countdown-container ended">
      <div className="conference-countdown-frame">
        <div className="conference-countdown-corner tl"></div>
        <div className="conference-countdown-corner tr"></div>
        <div className="conference-countdown-corner bl"></div>
        <div className="conference-countdown-corner br"></div>
        <div className="conference-countdown-ended">
          <div className="conference-ended-icon" aria-hidden="true">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <circle cx="12" cy="12" r="10" />
              <polyline points="12,6 12,12 16,14" />
            </svg>
          </div>
          <h2 className="conference-ended-title">{title}</h2>
          <p className="conference-ended-desc">{description}</p>
        </div>
        <div className="conference-countdown-scanline"></div>
      </div>
    </div>
  );
}

export default ConferenceCountdown;
